namespace SP {
    export interface supplierInfo {
        id: number;
        active: boolean;
        customerId: string;
        email: string;
        expectedDeliveryDays: number;
        externalId: string;
        importNames: string;
        minimumOrderAmount: number;
        name: string;
        phone: string;
    }

}